import React from 'react';
import {Flex, Text} from '@priority-software/priority-style-react';
import texts from '../texts';
import styles from '../styles/ToDoListConent.module.scss';
import allTasksDone from '../../../images/allTasksDone.png';

export const EmptyState = () => {
    return (
        <Flex componentClasses={styles.emptyStateContainer} direction="column">
            <img
                width={186}
                height={170}
                src={allTasksDone}
                draggable={false}
                className={styles.emptyStateImg}
            />
            <Text
                skin="paragraph-1"
                textColor="secondary-500"
                componentClasses={styles.emptyStateTxt}
            >
                {texts.empty_state}
            </Text>
        </Flex>
    );
};
